const message = {
  hello: 'Hallo {name}',
  evolution: 'Evolutie',
  from: 'Van',
  to: 'Tot',
  vitamins: 'Vitamines',
  for: 'Voor',
  current: 'Actueel',
  current_value: 'Huidige waarde',
  team: 'Team',
  average: 'Gemiddelde',
  median: 'Mediaan',
  company: 'Bedrijf',
  score: 'Vitamin Index Points',
  new: 'Nieuw',
  activity_log: 'Activiteitenrapport',
  dashboard: 'Dashboard',
  sign_out: 'Uitloggen',
  preferences: 'Voorkeuren',
  light_mode: 'Light mode',
  dark_mode: 'Dark mode',
  manager: 'Manager',
  hr: 'HR',
  company_settings: 'Bedrijfsinstellingen',
  continue: 'Voortzetten',
  no: 'Nee',
  finalized: 'Finaal',
  reviewed: 'Besproken',
  draft: 'Concept',
  show_previous_score: 'Toon vorige score',
  next_page: 'Volgende pagina',
  previous_page: 'Vorige pagina',
  save_draft: 'Concept opslaan',
  finalize: 'Afwerken',
  current_score: 'Huidige score',
  previous_score: 'Vorige score',
  team_average: 'Teamgemiddelde',
  company_average: 'Bedrijfsgemiddelde',
  comments_questions: 'Opmerkingen/vragen',
  overview: 'Overzicht',
  step: 'Stap',
  introduction: 'Introductie',
  please_complete_the_following_steps_to_begin: 'Gelieve de volgende stappen te doorlopen om te beginnen.',
  next: 'Volgende',
  back: 'Terug',
  previous: 'Vorige',
  skip_setup: 'Setup overslaan',
  server_setup: 'Server setup',
  server_url: 'Server URL',
  port: 'Poort',
  test_connection: 'Test connectie',
  connection_ok: 'Connectie ok!',
  my_profile: 'Mijn profiel',
  personal: 'Persoonsgegevens',
  contact: 'Contact',
  account: 'Account',
  tags: 'Trefwoorden',
  perks: 'Voordelen',
  first_name: 'Voornaam',
  last_name: 'Achternaam',
  birthdate: 'Geboortedatum',
  gender: 'Geslacht',
  marital_state: 'Burgerlijke staat',
  degree: 'Opleiding',
  education: 'Opleiding',
  mode_of_transportation: 'Vervoersmiddel',
  add_child: 'Kind toevoegen',
  child_name: 'Naam van kind',
  age: 'Leeftijd',
  actions: 'Acties',
  save_user: 'Gebruiker opslaan',
  male: 'Mannelijk',
  female: 'Vrouwelijk',
  other: 'Andere',
  not_married: 'Niet getrouwd',
  married: 'Getrouwd',
  divorced: 'Gescheiden',
  widowed: 'Weduwe/weduwnaar',
  choose: 'Kies',
  primary: 'Basisonderwijs',
  secondary: 'Secundair onderwijs',
  bachelor: 'Bachelor',
  master: 'Master',
  doctorate: 'Doctoraat',
  car: 'Wagen',
  bike: 'Fiets',
  foot: 'Te voet',
  public_transportation: 'Openbaar vervoer',
  in_family: 'Woont thuis',
  choose_a_status: 'Kies een status',
  active: 'Actief',
  archived: 'Gearchiveerd',
  yes: 'ja',
  street: 'Straat',
  number: 'Nummer',
  bus: 'Bus',
  zip_postal_code: 'Postcode',
  city: 'Stad',
  country: 'Land',
  email: 'E-mail',
  change_password: 'Wachtwoord veranderen',
  confirm_password: 'Wachtwoord bevestigen',
  user_is_finalized: 'Gebruikersaccount is klaar',
  select_to_add_a_tag: 'Kies om een trefwoord toe te voegen',
  select_to_add_a_perk: 'Kies om een voordeel toe te voegen',
  tag: 'Trefwoord',
  perk: 'Voordeel',
  description: 'beschrijving',
  log_in: 'Inloggen',
  company_details: 'Bedrijfsgegevens',
  company_info: 'Bedrijfsinformatie',
  company_name: 'Bedrijfsnaam',
  company_logo: 'Bedrijfslogo',
  user_settings: 'Gebruikersinstellingen',
  save_company: 'Bedrijf opslaan',
  cancel: 'Annuleren',
  save: 'Opslaan',
  create_new_tag: 'Creëer een nieuw trefwoord',
  create_a_new_perk: 'Creëer een nieuw voordeel',
  main_user_account: 'Hoofdgebruiker',
  company_setup: 'Bedrijfssetup',
  information: 'Informatie',
  logo: 'Logo',
  complete_setup: 'Setup afronden',
  you: 'Jij',
  filter: 'Filter',
  operator: 'Operator',
  and: 'En',
  or: 'Of',
  not: 'Niet',
  add_filter: 'Filter toevoegen',
  clear: 'Wissen',
  equals: 'Is',
  does_not_equal: 'Is niet',
  contains: 'Bevat',
  does_not_contain: 'Bevat niet',
  is_less_than: 'Is minder dan',
  is_more_than: 'Is meer dan',
  is_near: 'Is in de buurt van',
  choose_a_field: 'Kies een veld',
  score_difference_from_company: 'Scoreverschil met bedrijf',
  score_difference_from_team: 'Scoreverschil met team',
  role: 'Rol',
  lowest: 'Laagste',
  highest: 'Hoogste',
  start_of_employment: 'Begin tewerkstelling',
  end_of_employment: 'Einde tewerkstelling',
  reason_for_termination: 'Reden van stopzetting',
  team_fields: 'Teamvelden',
  user_fields: 'Gebruikersvelden',
  title: 'Titel',
  seniority: 'Anciënniteit',
  mode_of_transport: 'Vervoerswijze',
  children: 'Kinderen',
  value: 'Waarde',
  user_list: 'Gebruikers',
  first: 'Eerste',
  last: 'Laatste',
  last_evaluation: 'Laatste evaluatie',
  team_overview: 'Teamoverzicht',
  add_team: 'Team toevoegen',
  saved_filters: 'Bewaarde filters',
  users: 'Gebruikers',
  edit_team: 'Team bewerken',
  image: 'Afbeelding',
  team_name: 'Teamnaam',
  parent_team: 'Bovenliggend team',
  managed_by: 'Beheerd door',
  members: 'Leden',
  close: 'Sluiten',
  add_team_manager: 'Manager toevoegen',
  add_team_member: 'Lid toevoegen',
  professional: 'Professioneel',
  employment: 'Tewerkstelling',
  add_user: 'Gebruiker toevoegen',
  posted_draft: 'Concept opgeslagen',
  posted_final: 'Vitamins ingediend',
  reviewed_submission: 'Vitamins besproken',
  edited_company: 'Bedrijf bewerkt',
  edited_user: 'Gebruiker bewerkt',
  edited_team: 'Team bewerkt',
  edited_team_members: 'Edited team members',
  added_team_member: 'Teamlid toegevoegd',
  removed_team_member: 'Teamlid verwijderd',
  created_team: 'Team toegevoegd',
  added_child: 'Kind toegevoegd',
  create_a_team: 'Creëer een team',
  drop_your_image_here: 'Sleep hier je afbeelding',
  none: 'Geen',
  testing: 'Testen',
  password: 'Wachtwoord',
  cannot_be_empty: 'mag niet leeg zijn',
  email_is_not_valid: 'Email is niet geldig',
  password_needs_to_be_at_least_characters_long: 'Wachtwoord moet minstens {length} tekens lang zijn',
  passwords_do_not_match: 'Wachtwoorden komen niet overeen',
  target_server_full: 'Doelserver bevat al een hoofdgebruiker.',
  reset_password: 'Wachtwoord reset',
  confirm_reset: 'Bevestigen',
  this_page_does_not_exist: 'Deze pagina bestaat niet.',
  back_to_homepage: 'Terug naar de website',
  forgot_your_password: 'Wachtwoord vergeten?',
  team_score: 'Teamscore',
  company_score: 'Bedrijfsscore',
  saved_filter: 'Filter opgeslagen',
  created_user: 'Nieuwe gebruiker',
  edited_child: 'Kind bewerkt',
  type_delete_to_confirm: 'Typ \'DELETE\' om te bevestigen',
  delete_team: 'Team verwijderen',
  warning_this_cannot_be_undone: 'OPGELET: dit kan niet ongedaan worden gemaakt',
  firstname: 'Voornaam',
  lastname: 'Achternaam',
  manage_users: 'Gebruikersbeheer',
  name: 'Naam',
  submit: 'Verzenden',
  please_wait: 'Een ogenblik geduld',
  vitamins_are_being_loaded: 'Uw inzendingen worden opgehaald',
  is_finalized: 'Is finaal',
  back_to_login: 'Terug naar login',
  reset_mail_sent: 'Reset e-mail werd verzonden',
  no_submissions_yet: 'Je hebt nog geen vitamines',
  start_first_vitamin: 'Vul je eerste vitamines in',
  country_AD: 'Andorra',
  country_AE: 'Verenigde Arabische Emiraten',
  country_AF: 'Afghanistan',
  country_AG: 'Antigua en Barbuda',
  country_AI: 'Anguilla',
  country_AL: 'Albanië',
  country_AM: 'Armenië',
  country_AO: 'Angola',
  country_AQ: 'Antarctica',
  country_AR: 'Argentinië',
  country_AS: 'Amerikaans-Samoa',
  country_AT: 'Oostenrijk',
  country_AU: 'Australië',
  country_AW: 'Aruba',
  country_AX: 'Åland',
  country_AZ: 'Azerbeidzjan',
  country_BA: 'Bosnië en Herzegovina',
  country_BB: 'Barbados',
  country_BD: 'Bangladesh',
  country_BE: 'België',
  country_BF: 'Burkina Faso',
  country_BG: 'Bulgarije',
  country_BH: 'Bahrein',
  country_BI: 'Burundi',
  country_BJ: 'Benin',
  country_BL: 'Saint-Barthélemy',
  country_BM: 'Bermuda',
  country_BN: 'Brunei',
  country_BO: 'Bolivia',
  country_BQ: 'Caribisch Nederland',
  country_BR: 'Brazilië',
  country_BS: 'Bahama\'s',
  country_BT: 'Bhutan',
  country_BV: 'Bouveteiland',
  country_BW: 'Botswana',
  country_BY: 'Wit-Rusland',
  country_BZ: 'Belize',
  country_CA: 'Canada',
  country_CC: 'Cocoseilanden',
  country_CD: 'Congo-Kinshasa',
  country_CF: 'Centraal-Afrikaanse Republiek',
  country_CG: 'Congo-Brazzaville',
  country_CH: 'Zwitserland',
  country_CI: 'Ivoorkust',
  country_CK: 'Cookeilanden',
  country_CL: 'Chili',
  country_CM: 'Kameroen',
  country_CN: 'China',
  country_CO: 'Colombia',
  country_CR: 'Costa Rica',
  country_CU: 'Cuba',
  country_CV: 'Kaapverdië',
  country_CW: 'Curaçao',
  country_CX: 'Christmaseiland',
  country_CY: 'Cyprus',
  country_CZ: 'Tsjechië',
  country_DE: 'Duitsland',
  country_DJ: 'Djibouti',
  country_DK: 'Denemarken',
  country_DM: 'Dominica',
  country_DO: 'Dominicaanse Republiek',
  country_DZ: 'Algerije',
  country_EC: 'Ecuador',
  country_EE: 'Estland',
  country_EG: 'Egypte',
  country_EH: 'Westelijke Sahara',
  country_ER: 'Eritrea',
  country_ES: 'Spanje',
  country_ET: 'Ethiopië',
  country_FI: 'Finland',
  country_FJ: 'Fiji',
  country_FK: 'Falklandeilanden',
  country_FM: 'Micronesia',
  country_FO: 'Faeröer',
  country_FR: 'Frankrijk',
  country_GA: 'Gabon',
  country_GB: 'Verenigd Koninkrijk',
  country_GD: 'Grenada',
  country_GE: 'Georgië',
  country_GF: 'Frans-Guyana',
  country_GG: 'Guernsey',
  country_GH: 'Ghana',
  country_GI: 'Gibraltar',
  country_GL: 'Groenland',
  country_GM: 'Gambia',
  country_GN: 'Guinee',
  country_GP: 'Guadeloupe',
  country_GQ: 'Equatoriaal-Guinea',
  country_GR: 'Griekenland',
  country_GS: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
  country_GT: 'Guatemala',
  country_GU: 'Guam',
  country_GW: 'Guinee-Bissau',
  country_GY: 'Guyana',
  country_HK: 'Hongkong',
  country_HM: 'Heard en McDonaldeilanden',
  country_HN: 'Honduras',
  country_HR: 'Kroatië',
  country_HT: 'Haïti',
  country_HU: 'Hongarije',
  country_ID: 'Indonesië',
  country_IE: 'Ierland',
  country_IL: 'Israël',
  country_IM: 'Man',
  country_IN: 'India',
  country_IO: 'Brits Indische Oceaanterritorium',
  country_IQ: 'Irak',
  country_IR: 'Iran',
  country_IS: 'IJsland',
  country_IT: 'Italië',
  country_JE: 'Jersey',
  country_JM: 'Jamaica',
  country_JO: 'Jordanië',
  country_JP: 'Japan',
  country_KE: 'Kenia',
  country_KG: 'Kirgizië',
  country_KH: 'Cambodja',
  country_KI: 'Kiribati',
  country_KM: 'Comoren',
  country_KN: 'Saint Kitts en Nevis',
  country_KP: 'Noord-Korea',
  country_KR: 'Zuid-Korea',
  country_KW: 'Koeweit',
  country_KY: 'Kaaimaneilanden',
  country_KZ: 'Kazachstan',
  country_LA: 'Laos',
  country_LB: 'Libanon',
  country_LC: 'Saint Lucia',
  country_LI: 'Liechtenstein',
  country_LK: 'Sri Lanka',
  country_LR: 'Liberia',
  country_LS: 'Lesotho',
  country_LT: 'Litouwen',
  country_LU: 'Luxemburg',
  country_LV: 'Letland',
  country_LY: 'Libië',
  country_MA: 'Marokko',
  country_MC: 'Monaco',
  country_MD: 'Moldavië',
  country_ME: 'Montenegro',
  country_MF: 'Sint-Maarten',
  country_MG: 'Madagaskar',
  country_MH: 'Marshalleilanden',
  country_MK: 'Noord-Macedonië',
  country_ML: 'Mali',
  country_MM: 'Myanmar',
  country_MN: 'Mongolië',
  country_MO: 'Macau',
  country_MP: 'Noordelijke Marianen',
  country_MQ: 'Martinique',
  country_MR: 'Mauritanië',
  country_MS: 'Montserrat',
  country_MT: 'Malta',
  country_MU: 'Mauritius',
  country_MV: 'Maldiven',
  country_MW: 'Malawi',
  country_MX: 'Mexico',
  country_MY: 'Maleisië',
  country_MZ: 'Mozambique',
  country_NA: 'Namibië',
  country_NC: 'Nieuw-Caledonië',
  country_NE: 'Niger',
  country_NF: 'Norfolk',
  country_NG: 'Nigeria',
  country_NI: 'Nicaragua',
  country_NL: 'Nederland',
  country_NO: 'Noorwegen',
  country_NP: 'Nepal',
  country_NR: 'Nauru',
  country_NU: 'Niue',
  country_NZ: 'Nieuw-Zeeland',
  country_OM: 'Oman',
  country_PA: 'Panama',
  country_PE: 'Peru',
  country_PF: 'Frans-Polynesië',
  country_PG: 'Papoea-Nieuw-Guinea',
  country_PH: 'Filipijnen',
  country_PK: 'Pakistan',
  country_PL: 'Polen',
  country_PM: 'Saint-Pierre en Miquelon',
  country_PN: 'Pitcairneilanden',
  country_PR: 'Puerto Rico',
  country_PS: 'Palestina',
  country_PT: 'Portugal',
  country_PW: 'Palau',
  country_PY: 'Paraguay',
  country_QA: 'Qatar',
  country_RE: 'Réunion',
  country_RO: 'Roemenië',
  country_RS: 'Servië',
  country_RU: 'Rusland',
  country_RW: 'Rwanda',
  country_SA: 'Saoedi-Arabië',
  country_SB: 'Salomonseilanden',
  country_SC: 'Seychellen',
  country_SD: 'Soedan',
  country_SE: 'Zweden',
  country_SG: 'Singapore',
  country_SH: 'Sint-Helena, Ascension en Tristan da Cunha',
  country_SI: 'Slovenië',
  country_SJ: 'Spitsbergen en Jan Mayen',
  country_SK: 'Slowakije',
  country_SL: 'Sierra Leone',
  country_SM: 'San Marino',
  country_SN: 'Senegal',
  country_SO: 'Somalië',
  country_SR: 'Suriname',
  country_SS: 'Zuid-Soedan',
  country_ST: 'Sao Tomé en Principe',
  country_SV: 'El Salvador',
  country_SX: 'Sint Maarten',
  country_SY: 'Syrië',
  country_SZ: 'Swaziland',
  country_TC: 'Turks- en Caicoseilanden',
  country_TD: 'Tsjaad',
  country_TF: 'Franse Zuidelijke en Antarctische Gebieden',
  country_TG: 'Togo',
  country_TH: 'Thailand',
  country_TJ: 'Tadzjikistan',
  country_TK: 'Tokelau',
  country_TL: 'Oost-Timor',
  country_TM: 'Turkmenistan',
  country_TN: 'Tunesië',
  country_TO: 'Tonga',
  country_TR: 'Turkije',
  country_TT: 'Trinidad en Tobago',
  country_TV: 'Tuvalu',
  country_TW: 'Taiwan',
  country_TZ: 'Tanzania',
  country_UA: 'Oekraïne',
  country_UG: 'Oeganda',
  country_UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
  country_US: 'Verenigde Staten',
  country_UY: 'Uruguay',
  country_UZ: 'Oezbekistan',
  country_VA: 'Vaticaanstad',
  country_VC: 'Saint Vincent en de Grenadines',
  country_VE: 'Venezuela',
  country_VG: 'Britse Maagdeneilanden',
  country_VI: 'Amerikaanse Maagdeneilanden',
  country_VN: 'Vietnam',
  country_VU: 'Vanuatu',
  country_WF: 'Wallis en Futuna',
  country_WS: 'Samoa',
  country_YE: 'Jemen',
  country_YT: 'Mayotte',
  country_ZA: 'Zuid-Afrika',
  country_ZM: 'Zambia',
  country_ZW: 'Zimbabwe',
  go_to_user_management: 'Ga naar gebruikersbeheer',
  are_you_sure: 'Ben je zeker?',
  employment_active: 'Momenteel in dienst',
  delete: 'Verwijderen',
  Number: 'Nummer',
  Bus: 'Bus',
  zipcode: 'Postcode',
  must_be_alphanumeric: 'mag enkel alfanumerieke tekens bevatten (a-z, 0-9)',
  select_a_filter: 'Opgeslagen filters',
  filter_name_empty: 'Filter name cannot be empty',
  delete_filter: 'Delete filter',
  settings: 'Instellingen',
  email_or_password_invalid: 'E-mail of wachtwoord is ongeldig',
  please_provide_password: 'Gelieve uw wachtwoord in te geven',
  delete_child: 'Verwijder kind',
  add_comment_question: 'Voeg een vraag of opmerking toe',
  language: 'Taal',
  user_search_result: '{amt} gebruikers gevonden',
  recent_users: 'Recente gebruikers',
  find_a_user: 'Zoek gebruikers',
  user: 'Gebruiker',
  managers: 'Managers',
  user_vitamins_are_being_loaded: 'Vitamines worden geladen',
  user_no_submissions_yet: 'Deze gebruiker heeft nog geen vitamines ingezonden',
  back_to_users: 'Terug naar gebruikers',
  status: 'Status',
  teams: 'Teams',
  oneens_eens_1: 'Helemaal oneens',
  oneens_eens_2: 'Oneens',
  oneens_eens_3: 'Eerder oneens',
  oneens_eens_4: 'Noch eens, noch oneens',
  oneens_eens_5: 'Eerder eens',
  oneens_eens_6: 'Eens',
  oneens_eens_7: 'Helemaal eens',
  nooit_altijd_1: 'Nooit',
  nooit_altijd_2: 'Sporadisch',
  nooit_altijd_3: 'Af en toe',
  nooit_altijd_4: 'Regelmatig',
  nooit_altijd_5: 'Dikwijls',
  nooit_altijd_6: 'Zeer dikwijls',
  nooit_altijd_7: 'Altijd',
  ontevreden_tevreden_1: 'Helemaal ontevreden',
  ontevreden_tevreden_2: 'Ontevreden',
  ontevreden_tevreden_3: 'Eerder ontevreden',
  ontevreden_tevreden_4: 'Noch tevreden, noch ontevreden',
  ontevreden_tevreden_5: 'Eerder tevreden',
  ontevreden_tevreden_6: 'Tevreden',
  ontevreden_tevreden_7: 'Helemaal tevreden',
  view: 'Bekijken',
  review: 'Bespreken',
  tree: 'Structuur',
  heatmap: 'Heat map',
  activity: 'Activiteit',
  more_details: 'Details bekijken',
  team_index: 'Team index',
  vip: 'VIP',
  submit_review: 'Bespreking indienen',
  stddev: 'Standaardafwijking',
  delete_user: 'Gebruiker verwijderen',
  comment_placeholder: 'Hier kan je vragen of opmerkingen noteren in verband met {subcategory}',
  vitamin_overview_for: 'Vitamins for {username}',
  back_to_userlist: 'Terug naar gebruikersoverzicht',
  unknown: 'Onbekend',
  years_seniority: 'Jaren in dienst',
  workingyears: 'Jaren in dienst',
  demographics: 'Demographics',
  show_results_by_demographic: 'Results by demographic',
  choose_a_demographic: 'Kies een categorie',
  hide_submission: 'Zichtbaarheid inzending',
  passwords_no_match: 'Wachtwoorden komen niet overeen',
  add_as_member: 'Voeg gebruiker toe als teamlid',
  add_as_manager: 'Voeg gebruiker toe als manager',
  no_results_yet: 'Er zijn geen gegevens beschikbaar',
  password_min_6_long: 'Je wachtwoord moet minstens 6 tekens lang zijn',
  accesslevel: 'Toegangsniveau',
  import_users: 'Gebruikers importeren',
  download_template: 'Sjabloon downloaden',
  first_x_records: 'Eerste {amt} rijen',
  maritalstatus: 'Burgerlijke staat',
  Street: 'Straat',
  stateprovince: 'Provincie',
  jobtitle: 'Titel',
  employmentstart: 'Begin tewerkstelling',
  employmentend: 'Einde tewerkstelling',
  terminationreason: 'Reden stopzetting',
  degreelevel: 'Opleiding',
  modeoftransport: 'Transportmiddel',
  x_invalid_rows: '{amt} ongeldige rijen',
  $ERR_REQ: 'Dit veld is verplicht!',
  $ERR_DATE: 'Ongeldige datum!',
  $ERR_INVALID: 'Ongeldig!',
  x_records_processed: '{amt} rijen verwerkt',
  x_users_imported_successfully: '{amt} gebruikers met succes toegevoegd',
  x_users_could_not_be_imported: '{amt} gebruikers konden niet worden toegevoegd',
  the_following_errors_occurred: 'De volgende fouten zijn opgetreden',
  row: 'Rij',
  click_to_add_csv: 'Upload een .csv-bestand',
  must_be_dmyyyy_or_iso: 'Moet in DD/MM/YYYY of geldig ISO-formaat staan',
  field_value_restrictions: 'Geldige waardes: {values}',
  invalid_country: 'Moet een geldige ISO 3166-1 alpha-2 landcode bevatten',
  misc_server_error: 'Er is een fout opgetreden',
  emailtaken_server_error: 'Dit emailadres is reeds in gebruik',
  seniority_entry:'Entry-level',
  seniority_mid:'Mid-level',
  seniority_senior:'Senior',
  member_of:'Lid van',
  admin_of:'Beheerder van',
  manager_of:'Manager van',
  remove_from_team:'Verwijder uit team',
  expand_all: 'Alles tonen',
  collapse_all: 'Leden verbergen',
};

export default {
  message
}



// WEBPACK FOOTER //
// ./src/nl.js